// removed by extract-text-webpack-plugin
module.exports = {"fromList":"addAcount_fromList_6sBql"};


//////////////////
// WEBPACK FOOTER
// ./src/components/admin/index/addAcount.scss
// module id = 1519
// module chunks = 0